import { checkVAT } from 'jsvat'
import { WRONG_VAT } from 'constants/paymentSettingShared.constants'

export const validateJSVAT = (id: string) => checkVAT(id || WRONG_VAT)
